/**
 * @generated SignedSource<<8885cf5635ee0be3e40962a90430304b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChangePasswordForm_UserFragment$data = {
  readonly isLocked: boolean;
  readonly " $fragmentType": "ChangePasswordForm_UserFragment";
};
export type ChangePasswordForm_UserFragment$key = {
  readonly " $data"?: ChangePasswordForm_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChangePasswordForm_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChangePasswordForm_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    }
  ],
  "type": "UserInformation",
  "abstractKey": null
};

(node as any).hash = "81a5658a466db50b1b2487874e6056b0";

export default node;
